var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"static-page-content",domProps:{"innerHTML":_vm._s(_vm.page.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }